<script setup lang="ts">
import { default as PrimeButton } from 'primevue/button'
import MultiSelect from 'primevue/multiselect'
import { type ComponentPublicInstance, ref } from 'vue'
import LoadingSpinner from '../icons/LoadingSpinner.vue'
import { SelectFilter, type SelectProps, useSelect } from '../primevue/select'

const props = defineProps<Pick<SelectProps, 'options' | 'loadOptions' | 'ensureSelected'>>()
const model = defineModel<string[]>({ default: [] })
const rootElement = ref<ComponentPublicInstance | null>(null)
const { attrs, loading, loadOptions } = useSelect(model, props, rootElement)
</script>

<template>
  <MultiSelect ref="rootElement" v-bind="attrs" display="chip" :show-toggle-all="false" scroll-height="">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps" />
    </template>
    <template #header>
      <SelectFilter @update:modelValue="loadOptions" />
    </template>
    <template v-if="loading" #empty>
      <div class="flex items-center justify-center overflow-hidden">
        <LoadingSpinner class="h-16 w-16" />
      </div>
    </template>
    <template #footer>
      <div class="px-4 py-2 flex justify-end">
        <PrimeButton label="Clear" severity="secondary" size="small" icon="pi pi-times" @click="model = []" />
      </div>
    </template>
  </MultiSelect>
</template>
